module.exports = __webpack_public_path__ + "img/icon12.bc55c767.png";